import {Component, computed, effect, input, output, signal} from '@angular/core';
import {Campaign, CampaignUserStatus, Location, SwipeableComponent} from 'shared-lib';
import {NgIf} from '@angular/common';
import {LocationsGroup} from '../../../../../../shared-lib/src/lib/services/model';
import {CampaignLocationTuple} from '../map.component';
import {MapMarkerDetailsCardComponent} from '../map-marker-details-card/map-marker-details-card.component';

/**
 * Based on https://medium.com/@su.ede.kovacs/angular-carousel-e6953aa38f77
 */
@Component({
  selector: 'app-map-marker-details-carousel',
  templateUrl: './map-marker-details-carousel.component.html',
  styleUrl: './map-marker-details-carousel.component.scss',
  imports: [NgIf, SwipeableComponent, MapMarkerDetailsCardComponent, MapMarkerDetailsCardComponent, SwipeableComponent]
})
export class MapMarkerDetailsCarouselComponent {

  locationsCampaignMap = input.required<Map<Location, Campaign>>();
  campaignsUserStatus = input.required<CampaignUserStatus>();
  selectedLocation = input<Location>();
  locations = signal<Location[]>([]);
  selectedLocationChange = output<Location>();

  componentId: string | undefined = `carousel-id`;

  getCampaignWithSingleLocation = computed(() => {
    const campaignLocation: CampaignLocationTuple[] = [];
    this.locationsCampaignMap().forEach((campaign, location) => {
      campaignLocation.push({
        location: location,
        campaign: {...campaign, locationsGroup: {...campaign.locationsGroup, locations: [location]} as LocationsGroup}
      });
    });
    return campaignLocation.sort((a, b) => (a.location.id > b.location.id ? -1 : 1));
  });


  private _ = effect(() => {
    if (this.selectedLocation()) {
      const index = this.getCampaignWithSingleLocation().findIndex(tuple => tuple.location.id === this.selectedLocation()!.id);
      setTimeout(() => {
        this.scrollToElement(index);
      }, 200);
    }
  });
  private currentPage: number = 0;

  navToNext(): void {
    if (this.currentPage < this.getCampaignWithSingleLocation().length - 1) {
      this.currentPage = this.currentPage + 1;
      this.navigateToGroup(this.currentPage);
      this.selectedLocationChange.emit(this.getCampaignWithSingleLocation().at(this.currentPage)!.location);
    }
  }

  navToPrev(): void {
    if (this.currentPage >= 1) {
      this.currentPage = this.currentPage - 1;
      this.navigateToGroup(this.currentPage);
      this.selectedLocationChange.emit(this.getCampaignWithSingleLocation().at(this.currentPage)!.location);
    }
  }

  private navigateToGroup(groupId: number): void {
    const sliderGroup: Element | null = document.querySelector(
      `#${this.componentId}-group-${groupId}`
    );

    sliderGroup?.scrollIntoView({
      block: 'nearest',
      inline: 'center',
      behavior: 'smooth',
    });
  }

  private scrollToElement(index: number): void {
    if (this.currentPage !== index) {
      this.currentPage = index;
      this.navigateToGroup(this.currentPage);
    }
  }

}
